import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selection-list fill-height" },
    [
      _vm.searchResultsCount === 0
        ? _c(
            "div",
            { staticClass: "selection-list__not-found" },
            [_vm._t("not-found")],
            2
          )
        : !_vm.itemsDelayed.length
        ? _c(
            "div",
            { staticClass: "d-flex align-center justify-center fill-height" },
            [
              _c(VProgressCircular, {
                attrs: { color: "primary", size: "48", indeterminate: "" },
              }),
            ],
            1
          )
        : _c(
            VList,
            {
              staticClass: "selection-list__list py-0",
              class: _vm.counterXSpaceClass,
              attrs: { flat: "" },
            },
            [
              _c(
                VListItemGroup,
                {
                  attrs: { value: _vm.value, mandatory: _vm.mandatory },
                  on: { change: _vm.handleSelect },
                },
                _vm._l(_vm.itemsDelayed, function (item) {
                  return _c(
                    VListItem,
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.matchSearchQuery(item),
                          expression: "matchSearchQuery(item)",
                        },
                      ],
                      key: item.id,
                      staticClass: "selection-list__item",
                      class: [
                        {
                          "selection-list__item_small": _vm.smallItems,
                          "selection-list__item_hover": _vm.hover,
                        },
                        _vm.xSpaceClass || "px-2",
                      ],
                      attrs: { value: item.value },
                      on: {
                        click: function ($event) {
                          return _vm.handleClick(item.value)
                        },
                      },
                    },
                    [
                      _vm._t(
                        "item-content",
                        function () {
                          return [
                            _c(
                              VListItemContent,
                              [
                                _c(
                                  VListItemTitle,
                                  { staticClass: "text-body-1 text--text" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.text) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        null,
                        { item }
                      ),
                      _vm._v(" "),
                      !_vm.buttons && item.id === _vm.selectedItem?.id
                        ? _c(
                            VListItemIcon,
                            [
                              _c(
                                VIcon,
                                { attrs: { color: "primary", size: "24" } },
                                [
                                  _vm._v(
                                    "\n            ui-icon-check\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }